import { AuthRepository } from '../Repositories/AuthRepository';

export class RefreshTokenUseCase {
  constructor(private repo: AuthRepository) {}
  execute(refresh: string): Promise<{ access: string }> {
    return this.repo.refresh(refresh);
  }
}